/**
 * format.js — text formatting shared by the clip timeline and card badges.
 * Ported from mock FE (`fmtClipMmss`, `bufferedStatusSuffix`).
 */

export function fmtClipMmss(sec) {
  if (!isFinite(sec) || sec < 0) sec = 0;
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
}

/**
 * 2026-09-12 (owner feedback): the "chưa đủ 1 phút"/"xem được N phút đầu"
 * suffix was dropped — the M:SS/M:SS figures plus the VLC-style current/total
 * labels above the timeline already say the same thing without the extra
 * clause.
 */
export function clipTimelineText(bufferedSec, durationMs) {
  const durationSec = (durationMs || 0) / 1000;
  return `Đã tải: ${fmtClipMmss(bufferedSec)} / ${fmtClipMmss(durationSec)}`;
}
